import { takeLatest } from 'redux-saga'
import { put } from 'redux-saga/effects'
import { setCameraToActiveAction } from 'actions/cameraActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'
import { CHANGE_CAMERA } from 'actions/cameraActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export function* changeCamera(action) {
  try {
    const { id } = action

    yield put(setCameraToActiveAction(id))
    yield put(updatePresentationValuesAction())
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function* watchChangeCamera() {
  yield* takeLatest(CHANGE_CAMERA, changeCamera)
}



// WEBPACK FOOTER //
// ./src/sagas/changeCameraSaga.js